import { render, staticRenderFns } from "./presAdd.vue?vue&type=template&id=18f48842&scoped=true&"
import script from "./presAdd.vue?vue&type=script&lang=ts&"
export * from "./presAdd.vue?vue&type=script&lang=ts&"
import style0 from "./presAdd.vue?vue&type=style&index=0&id=18f48842&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f48842",
  null
  
)

export default component.exports